<template>
	<div class="ProjectNewDetail">
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-orderManage Icon"></i>
			<!-- <span class="p-l-10 p-r-10" >/</span> -->
			<span class="header_text">/ 项目任务 / 项目概况</span>
		</div>
		<div class="content_Box box-shadow p-l-10 p-r-10" :style="{ 'min-height': windowSizeHeight - 120 + 'px' }">
			<el-collapse v-model="activeNames">
				<el-collapse-item name="1">
					<template slot="title" style="background-color: red;">
						<b class="font-16 p-l-5">项目概况</b>
					</template>
					<div class="oneContent contentInfo">
						<div class="clear row-info">
							<div class="fl title-key">项目名称 ：</div>
							<div class="fl list-cont">{{ orderObj.project_name }}</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">省市 ：</div>
							<div class="fl list-cont">{{ orderObj.city }}</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">时间 ：</div>
							<div class="fl list-cont">{{ orderObj.start_time }} ~ {{ orderObj.end_time }}</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">类型 ：</div>
							<div class="fl list-cont">{{ orderObj.type }}</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">描述 ：</div>
							<div class="fl list-cont">
								<el-input type="textarea" readonly :rows="6" v-model="orderObj.content"></el-input>
							</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">地址 ：</div>
							<div class="fl list-cont">
								{{ orderObj.address | isData }}
							</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">参与人数 ：</div>
							<div class="fl list-cont">{{ orderObj.count }}人</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">已实名人数 ：</div>
							<div class="fl list-cont">{{ orderObj.signCount }}人</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">已签约 ：</div>
							<div class="fl list-cont">{{ orderObj.signCount }}人</div>
						</div>
						<div class="clear row-info" v-if="noSignCount > 0">
							<div class="fl title-key">未签约 ：</div>
							<div class="fl list-cont no-sign-sid" @click="goSignOrdertask">{{ noSignCount }}人</div>
						</div>
						<div class="clear row-info">
							<div class="fl title-key">状态 ：</div>
							<div class="fl list-cont">
								<span class="xm-state-0" v-if="orderObj.status == '0'">要素验证</span>
								<span class="xm-state-1" v-if="orderObj.status == '1'">待支付</span>
								<span class="xm-state-2" v-if="orderObj.status == '2'">待报审</span>
								<span class="xm-state-3" v-if="orderObj.status == '3'">已驳回</span>
								<span class="xm-state-4" v-if="orderObj.status == '4'">结算异常</span>
								<span class="xm-state-5" v-if="orderObj.status == '5'">已结算</span>
								<span class="xm-state-6" v-if="orderObj.status == '6'">审核中</span>
								<span class="xm-state-7" v-if="orderObj.status == '7'">结算中</span>
								<span class="xm-state-8" v-if="orderObj.status == '8'">已关闭</span>
								<span class="xm-state-6" v-if="orderObj.status == '9'">审核中</span>
								<span class="xm-state-10" v-if="orderObj.status == '10'">签约异常</span>
							</div>
						</div>
						<div class="clear p-l-90 p-t-10">
							<span class="blueBtn" @click="goOrderTask">任务派单列表</span>
						</div>
					</div>
				</el-collapse-item>
				<el-collapse-item name="2">
					<template slot="title">
						<b class="font-16 p-l-5">费用概览</b>
					</template>
					<div class="towContent contentInfo p-t-10">
						<div class="clear row-info">
							<div class="fl title-key">结算通道 ：</div>
							<div class="fl list-cont">
								<div
									class="channelList fl m-r-20"
									:class="channel_id == item.channel_id ? 'channelList-border-solid' : 'channelList-border-dashed'"
									v-for="(item, index) in available_balance"
									:key="index"
									@click="bankActive(item.channel_id)"
								>
									<p>{{ item.name }}</p>
									<p>
										余额：<span class="font-14"> {{ item.balance | filterNumber }}</span>
									</p>
								</div>
							</div>
						</div>
						<div v-if="channel_id != ''">
							<div class="clear row-info">
								<div class="fl title-key">打款金额 ：</div>
								<div class="fl list-cont">
									<span class="font-consolas">{{ orderObj.total_money | filterNumber }}</span> 元
									<span class="suffix">（{{ remitDX }}）</span>
								</div>
							</div>
							<div class="clear row-info">
								<div class="fl title-key">综合税费 ：</div>
								<div class="fl list-cont">
									<span class="font-consolas">{{ orderObj.rate_money | filterNumber }}</span> 元
									<span class="suffix">（含个人所得税、增值税、平台服务费）</span>
								</div>
							</div>
							<div class="clear row-info">
								<div class="fl title-key">总费用 ：</div>
								<div class="fl list-cont">
									<span class="font-consolas font-weight-700">{{ orderObj.settlement_money | filterNumber }}</span> 元
									<span class="suffix">（{{ sumDX }}）</span>
								</div>
							</div>
							<div class="clear row-info m-t-20">
								<span class="p-l-90 text-color-gray">* 根据结算通道不同，综合税费可能有所差异</span>
							</div>
						</div>
						<div class="clear"></div>
					</div>
				</el-collapse-item>
			</el-collapse>
			<div class="contentDetailBox m-b-20">
				<div class="clear row-info" v-if="orderObj.status == '1'">
					<div class="fl title-key">支付密码 ：</div>
					<div class="fl list-cont">
						<el-input show-password v-model.trim="pwd" maxlength="6" placeholder="请输入支付密码"></el-input>
					</div>
					<b class="hintText"> (6位数字) </b>
				</div>
				<div class="clear row-info m-t-10" v-if="orderObj.status == '3'">
					<div class="fl title-key">驳回原因 ：</div>
					<div class="fl list-cont">
						<div class="fl list-cont">
							<el-input type="textarea" readonly :rows="4" v-model="orderObj.cause"></el-input>
						</div>
					</div>
				</div>
				<div class="btn_box clear">
					<div>
						<div style="padding: 10px 0;">
							<span class="blueBtn m-r-20" @click="goToProjectList">项目列表</span>
							<span class="btnOK m-r-20" v-if="orderObj.status == '2'" @click="submitBtn">提交平台审核</span>
							<span class="greenBtn m-r-20" v-if="orderObj.status == '1'" @click="paymentBtn">确定支付</span>
						</div>
						<p class="SH-hint" v-if="orderObj.status == '6'">
							<b>项目正在审核中...</b>
						</p>
						<p class="BH-hint" v-if="orderObj.status == '3'">
							<b>项目已被驳回...</b>
						</p>
						<div class="submitHint" v-if="orderObj.status == '2'">
							<p>1. 根据监管要求，平台需要对项目进行合法合规性审核；</p>
							<p>2. 项目后续进展可以在项目列表追踪；</p>
							<p>3. 所有订单国家相关单位会审查；</p>
							<p>4. 严禁利用平台进行偷税漏税或洗钱等非法行为。</p>
						</div>
						<div class="submitHint" v-if="orderObj.status == '7'">
							<p>您的订单支付成功，已经提交给银行处理</p>
							<p>可以返回项目列表查看发放情况</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { common } from '../../static/tool.js'
import { mainfun } from '../assets/js/main.js'
export default {
	name: 'ProjectNewDetail',
	data() {
		return {
			windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
			screenHeight: document.documentElement.clientHeight,
			orderObj: {}, //项目数据集合
			projectId: '', //项目id
			url: common.url,
			activeNames: ['1', '2'],
			pwd: '', //支付密码
			available_balance: [], //税源地 账户余额
			hintMoney: '',
			hintBalanceMoneyShow: true, //true 可以支付   false  不可以支付
			remitDX: '', //大写金额  实际打款
			sumDX: '', //大写金额  总费用
			rateDx: '', //税费额
			channel_id: '', //通道选择了
			noSignCount: 0 //没签约人数
		}
	},
	mounted() {
		this.startResult()
	},
	methods: {
		startResult() {
			if (!sessionStorage.getItem('userInfo')) {
				//判断是否登录
				window.location = 'login.html'
				return
			}
			this.projectId = this.$route.query.id
			this.getProjectDetails() //获取项目详情
			this.getBalance() //获取账户余额
		},
		getBalance() {
			//获取账户余额
			this.$http.post(this.url + '/zhongfy/company/getPayChannelList').then(
				res => {
					let data = res.data
					if (data.code == '200') {
						this.available_balance = data.data
					} else if (data.code == '8886') {
						//code   8886  登录过期
						sessionStorage.clear()
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html'
							}
						})
						return
					} else {
						return
					}
				},
				err => {
					return
				}
			)
		},

		getProjectDetails() {
			//获取项目详情
			if (this.projectId == '' || this.projectId == undefined) {
				this.$router.push('/projectManage')
				return
			}
			let fn = new FormData()
			fn.append('id', this.projectId)
			this.$http.post(this.url + '/zhongfy/company/ProjectDetails', fn).then(
				res => {
					let data = res.data
					if (data.code == '200' || data.msg == '成功') {
						this.orderObj = data.data
						this.channel_id = data.data.channel_id //结算通道id
						this.remitDX = this.DX(this.orderObj.total_money)
						this.rateDx = this.DX(this.orderObj.rate_money)
						this.sumDX = this.DX(this.orderObj.settlement_money)
						this.noSignCount = this.orderObj.no_sign_sid.length
					} else if (data.code == '8886') {
						//code   8886  登录过期
						sessionStorage.clear()
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html'
							}
						})
						return
					} else {
						this.$message.error(data.msg)
						return
					}
				},
				err => {
					this.$message.error('网络错误')
					return
				}
			)
		},
		submitBtn() {
			//提交审核
			// if(this.orderObj.signCount != this.orderObj.count ){
			// 	this.$alert('<strong> 有人员未签约，无法提交平台审核！ </strong>', '提示', {
			// 	    dangerouslyUseHTMLString: true
			// 	});
			// 	return;
			// }
			if (this.channel_id == '') {
				this.$alert('<strong> 请选择结算通道！ </strong>', '提示', {
					dangerouslyUseHTMLString: true
				})
				return
			}
			console.log(this.channel_id)
			let fn = new FormData()
			fn.append('channel_id', this.channel_id) //结算通道id
			fn.append('id', this.projectId) //基本信息id
			this.$http.post(this.url + '/zhongfy/company/SubmitAdmin', fn).then(
				res => {
					let data = res.data
					if (data.code == '200' || data.msg == '提交成功') {
						this.getProjectDetails()
						// this.$router.push('/projectManage');
					} else if (data.code == '8886') {
						//code   8886  登录过期
						sessionStorage.clear()
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html'
							}
						})
						return
					} else {
						this.$message.error(data.msg)
						return
					}
				},
				err => {
					this.$message.error('网络错误')
					return
				}
			)
		},
		paymentBtn() {
			//支付按钮
			let channel = this.available_balance.filter(val => {
				return val.channel_id == this.channel_id
			})
			channel = channel[0]
			if (Number(channel.balance) < Number(this.orderObj.settlement_money)) {
				this.$alert('<strong>余额不足无法支付请先充值账户!</strong>', '提示', {
					dangerouslyUseHTMLString: true
				})
				return
			}
			if (this.pwd == '') {
				this.$alert('<strong>请输入密码!</strong>', '提示', {
					dangerouslyUseHTMLString: true
				})
				return
			}

			// 支付密码验证
			let fn = new FormData()
			fn.append('PayPassword', this.pwd) //项目id
			this.$http.post(this.url + '/zhongfy/bank/PayPassword', fn).then(
				res => {
					let data = res.data
					if (data.code == '200' || data.msg == '成功') {
						this.orderPay()
					} else if (data.code == '8886') {
						//code   8886  登录过期
						sessionStorage.clear()
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html'
							}
						})
						return
					} else {
						// this.$message.error(data.msg);
						this.$alert('<strong>' + data.msg + '</strong>', '提示', {
							dangerouslyUseHTMLString: true
						})
						return
					}
				},
				err => {
					this.$message.error('网络错误')
					return
				}
			)
		},
		// 支付 函数
		orderPay() {
			let fn = new FormData()
			fn.append('id', this.projectId) //项目id
			this.$http.post(this.url + '/zhongfy/bank/orderPay', fn).then(
				res => {
					let data = res.data
					if (data.code == '200' || data.msg == '成功') {
						this.getProjectDetails()
					} else if (data.code == '8886') {
						//code   8886  登录过期
						sessionStorage.clear()
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html'
							}
						})
						return
					} else {
						this.$message.error(data.msg)
						return
					}
				},
				err => {
					this.$message.error('网络错误')
					return
				}
			)
		},
		goToProjectList() {
			//项目列表
			this.$router.push('/projectManage')
		},
		goToFundRecharge() {
			//去充值
			this.$router.push('/fundRecharge')
		},
		goOrderTask() {
			//任务派单
			this.$router.push({
				path: '/orderTask',
				query: {
					pid: this.projectId
				}
			})
		},
		goSignOrdertask() {
			//任务派单 看未签约的人
			console.log(this.orderObj)
			this.$router.push({
				path: '/orderTask',
				query: {
					pid: this.projectId,
					sid: this.orderObj.no_sign_sid.join()
				}
			})
		},

		bankActive(channel_id) {
			//选定的结算通道
			if (this.orderObj.status == '2') {
				this.channel_id = channel_id
				let fn = new FormData()
				fn.append('channel_id', this.channel_id) //结算通道id
				fn.append('p_id', this.projectId) //项目id
				this.$http.post(this.url + '/zhongfy/company/rateMoney', fn).then(
					res => {
						let data = res.data
						console.log(data)
						if (data.code == '200' || data.msg == '成功') {
							this.orderObj.total_money = data.data.total_money
							this.orderObj.rate_money = data.data.rate_money
							this.orderObj.settlement_money = data.data.settlement_money
						} else if (data.code == '8886') {
							//code   8886  登录过期
							sessionStorage.clear()
							this.$alert('登录已过期，请重新登录 !', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									window.location = 'login.html'
								}
							})
							return
						} else {
							this.$message.error(data.msg)
							return
						}
					},
					err => {
						this.$message.error('网络错误')
						return
					}
				)
			}
		},
		//主函数
		DX(n) {
			if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return '数据非法'
			var unit = '千百拾亿千百拾万千百拾元角分',
				str = ''
			n += '00'
			var p = n.indexOf('.')
			if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2)
			unit = unit.substr(unit.length - n.length)
			for (var i = 0; i < n.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i)
			return str
				.replace(/零(千|百|拾|角)/g, '零')
				.replace(/(零)+/g, '零')
				.replace(/零(万|亿|元)/g, '$1')
				.replace(/(亿)万|壹(拾)/g, '$1$2')
				.replace(/^元零?|零分/g, '')
				.replace(/元$/g, '元整')
		}
	},
	filters: {}
}
</script>

<style scoped>
.contentDetailBox {
	display: block;
	padding: 10px 0;
}
.btn_box {
	display: block;
	margin: 0 0 0 82px;
}
.suffix {
	font-size: 12px !important;
	color: #999999;
}
.submitHint {
	text-align: left;
	color: #d0121b;
	font-size: 13px;
	margin-bottom: 20px;
	border: 1px solid red;
	width: 350px;
	padding: 10px;
	background-color: #f7de20;
	margin: 30px 0 30px 0;
	border-radius: 5px;
}
.font-red {
	color: #d0121b;
}
.submitHint p {
	line-height: 20px;
}

.no-sign-sid {
	color: #f5365c;
	text-decoration: underline;
	cursor: pointer;
}

/*  */
.oneContent {
	padding: 10px 0;
}
.hintText {
	line-height: 36px;
	color: var(--theme-orange);
}
.SH-hint {
	color: #2c4198;
	font-size: 40px;
	text-align: left;
	margin-bottom: 20px;
	margin-top: 10px;
}
.BH-hint {
	text-align: left;
	color: #d0121b;
	font-size: 40px;
	margin-bottom: 20px;
	margin-top: 10px;
}

.channelList {
	width: 180px;
	font-size: 12px;
	padding: 5px 10px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	border-radius: 5px;
}
.channelList-border-dashed {
	border: 1px dashed #888888;
}
.channelList-border-solid {
	border: 1px solid #0acf97;
	background: url('../assets/img/tongdaoDuihao.svg') bottom right no-repeat;
	background-color: #0acf9719;
	background-size: 30px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectNewDetail.vue